export default __webpack_public_path__ + "static/media/Image-16.9fde7b7e.jpg";